import { render, staticRenderFns } from "./MatchCard.vue?vue&type=template&id=9e4c2af2&scoped=true&"
import script from "./MatchCard.vue?vue&type=script&lang=js&"
export * from "./MatchCard.vue?vue&type=script&lang=js&"
import style0 from "./MatchCard.vue?vue&type=style&index=0&id=9e4c2af2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4c2af2",
  null
  
)

export default component.exports